import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import { getData } from "../Services/getData";
import { localUrlEnum, urlEnum } from "../Utils/urlEnum";
import { lang } from "../Utils/lang";
import { tableLayoutOnMobile } from "../Utils/Constants";
import { useLocation, useNavigate } from "react-router";
import { getPropsFromUrl } from "../Utils/utils";
import moment from "moment";
import { europeanDate, usDateFormatWithTime } from "../Utils/formatDate";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import LockIcon from "@mui/icons-material/Lock";
import GenericDialog from "../Components/Reusable/GenericDialog";
import { updateData } from "../Services/updateData";
import { Chip, IconButton, Tooltip } from "@mui/material";

export default function Companies() {
  const navigate = useNavigate();
  const location = useLocation();
  const [companies, setCompanies] = useState([]);
  const [nrCompanies, setNrCompanies] = useState(0);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [openModal, setOpenModal] = useState(false);

  const companiesColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "organization",
      label: lang.organization,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return tableMeta.rowData[1]?.databaseName || "";
        },
      },
    },
    {
      name: "email",
      label: lang.email,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "CUI",
      label: lang.cui,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return tableMeta.rowData[1]?.cui || "";
        },
      },
    },
    {
      name: "phoneNumber",
      label: lang.phoneNumber,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return tableMeta.rowData[1]?.phoneNumber || "";
        },
      },
    },
    {
      name: "Status",
      label: "Status",
      options: {
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return (
            <Chip
              label={
                tableMeta.rowData[1]?.suspended
                  ? lang.suspendedAccount
                  : lang.activeAccount
              }
              style={{
                backgroundColor: tableMeta.rowData[1]?.suspended
                  ? "#eb2828"
                  : "#359d35",
                color: "#fff",
              }}
            />
          );
        },
      },
    },
    {
      name: "createdAt",
      label: lang.createAt,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (date: any) => (
          <>
            {date
              ? moment(date, usDateFormatWithTime).format(europeanDate)
              : ""}
          </>
        ),
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right" }}>
            <Tooltip
              title={
                (companies[rowIndex] as any)?.organization?.suspended
                  ? lang.unsuspendAccount
                  : lang.suspendAccount
              }
            >
              <IconButton
                onClick={(event: any) => {
                  event.stopPropagation();
                  setOpenModal(companies[rowIndex]);
                }}
              >
                {(companies[rowIndex] as any)?.organization?.suspended ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // centers horizontally
                      justifyContent: "center", // centers vertically
                      width: 70, // set a fixed width to ensure consistency
                    }}
                  >
                    <LockIcon
                      style={{
                        height: 30,
                        cursor: "pointer",
                        color: "#eb2828",
                      }}
                    />
                    <div style={{ fontSize: 10, textAlign: "center" }}>
                      {lang.unsuspendAccount}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center", // centers horizontally
                      justifyContent: "center", // centers vertically
                      width: 70, // same width as above
                    }}
                  >
                    <LockOpenIcon
                      style={{
                        height: 30,
                        cursor: "pointer",
                        color: "#359d35",
                      }}
                    />
                    <div style={{ fontSize: 10, textAlign: "center" }}>
                      {lang.suspendAccount}
                    </div>
                  </div>
                )}
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    },
    {
      name: "suspended",
      label: "suspended",
      options: {
        filter: true,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
          return tableMeta.rowData[1]?.suspended || false;
        },
      },
    },
  ];

  const getDataForTable = () => {
    const search = getPropsFromUrl(location.search, "?");
    getData(
      `${urlEnum.organizations}?page=${search.page ? search.page : 0}&perPage=${
        search.perPage ? search.perPage : 10
      }`
    ).then((data: any) => {
      setCompanies(data.data.results);
      setNrCompanies(data.data.nrResults);
    });
  };

  useEffect(() => {
    getDataForTable();
  }, [location]);

  /**
   *
   */
  const options = {
    filter: false,
    download: false,
    responsive: tableLayoutOnMobile,
    sort: false,
    textLabels: {
      viewColumns: {
        title: "Afisare coloane",
        titleAria: "Afisare Coloane",
      },
      pagination: lang.pagination,
    },

    fixedHeader: false,
    fixedSelectColumn: false,
    selectableRows: "none" as any,
    print: false,
    page: page,
    serverSide: true,
    rowsPerPage: perPage,
    search: false,
    count: nrCompanies,
    rowHover: true,
    onChangePage: (page: number) => {
      setPage(page + 1);
      navigate(`${localUrlEnum.companies}?page=${page + 1}?perPage=${perPage}`);
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      setPerPage(numberOfRows);
      navigate(`${localUrlEnum.companies}?page=${1}?perPage=${numberOfRows}`);
      window.scrollTo(0, 0);
    },
  };

  function suspendCompany() {
    updateData(`${urlEnum.organizations}`, {
      organizationId: (openModal as any).organization.id,
    }).then((data: any) => {
      getDataForTable();
      setOpenModal(false);
    });
  }

  return (
    <div>
      <MUIDataTable
        title={""}
        data={companies}
        columns={companiesColumns}
        options={options}
      />
      <GenericDialog
        open={openModal}
        title={
          (openModal as any)?.organization?.suspended
            ? lang.unsuspendAccount
            : lang.suspendAccount
        }
        message={
          (openModal as any)?.organization?.suspended
            ? lang.unsuspendAccountDescription
            : lang.suspendAccountDescription
        }
        onClose={() => setOpenModal(false)}
        onOk={() => suspendCompany()}
        onCancel={() => setOpenModal(false)}
      />
    </div>
  );
}
